import React from "react";
import { Stack, Typography } from "@mui/material";
import { Lock } from "@mui/icons-material";

const SigninHeader = ({ children }) => {

  if (children) {
    return <>{children}</>;
  }

  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      spacing={1}>
      <Lock fontSize="small"/>
      <Typography variant="h4">
        Sign In
      </Typography>
    </Stack>
  );
};

export default SigninHeader;